import { motion } from 'framer-motion'
import { Star, Users, MapPin } from 'lucide-react'

const WhyChooseUsSection = () => {
  const features = [
    {
      icon: Star,
      title: 'Expert Planning',
      description: 'Our travel experts craft perfect itineraries tailored to your preferences and budget.'
    },
    {
      icon: Users,
      title: 'Personalized Service',
      description: 'Enjoy dedicated support throughout your journey with our 24/7 assistance.'
    },
    {
      icon: MapPin,
      title: 'Local Expertise',
      description: 'Benefit from insider knowledge and authentic experiences at every destination.'
    }
  ]

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Why Choose High View?
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            We're committed to providing exceptional travel experiences with personalized service 
            and attention to every detail.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="text-center p-6"
            >
              <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <feature.icon className="h-8 w-8 text-primary-600" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-gray-600">
                {feature.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default WhyChooseUsSection
